const i = ":host{display:inline-block}.sl-checkbox-wrapper{display:flex;align-items:center;gap:var(--sl-spacing-2)}.sl-checkbox-input{height:1rem;width:1rem;border-radius:var(--sl-radius-sm);border:1px solid hsl(var(--sl-hsl-input));background-color:hsl(var(--sl-hsl-background));color:hsl(var(--sl-hsl-primary));transition:all var(--sl-transition-fast);cursor:pointer;accent-color:hsl(var(--sl-hsl-primary))}.sl-checkbox-input:focus{outline:none;box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-checkbox-input--disabled{cursor:not-allowed;opacity:0.5}.sl-checkbox-label{font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);color:hsl(var(--sl-hsl-foreground));cursor:pointer}.sl-checkbox-input:disabled + .sl-checkbox-label{cursor:not-allowed;opacity:0.7}";
class l extends HTMLElement {
  constructor() {
    super(), this._input = null, this._handleChangeBound = this._handleChange.bind(this), this._shadow = this.attachShadow({ mode: "open" }), this._internalId = `sl-checkbox-${Math.random().toString(36).slice(2, 9)}`, this._render();
  }
  static get observedAttributes() {
    return ["checked", "disabled", "label", "name", "value", "id"];
  }
  connectedCallback() {
    this._input && this._input.addEventListener("change", this._handleChangeBound);
  }
  disconnectedCallback() {
    this._input && this._input.removeEventListener("change", this._handleChangeBound);
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._updateContent();
  }
  get checked() {
    return this.hasAttribute("checked");
  }
  set checked(e) {
    e ? this.setAttribute("checked", "") : this.removeAttribute("checked");
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get label() {
    return this.getAttribute("label") || "";
  }
  set label(e) {
    this.setAttribute("label", e);
  }
  get name() {
    return this.getAttribute("name");
  }
  set name(e) {
    e ? this.setAttribute("name", e) : this.removeAttribute("name");
  }
  get value() {
    return this.getAttribute("value") || "";
  }
  set value(e) {
    this.setAttribute("value", e);
  }
  _handleChange(e) {
    const t = e.target;
    t.checked ? this.setAttribute("checked", "") : this.removeAttribute("checked"), this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: !0,
        composed: !0,
        detail: { checked: t.checked }
      })
    );
  }
  _updateContent() {
    if (!this._input) return;
    const e = this.getAttribute("id") || this._internalId, t = ["sl-checkbox-input"];
    this.disabled && t.push("sl-checkbox-input--disabled"), this._input.id = e, this._input.className = t.join(" "), this._input.checked = this.checked, this._input.disabled = this.disabled, this.name ? this._input.name = this.name : this._input.removeAttribute("name"), this._input.value = this.value;
    const s = this._shadow.querySelector("label");
    s && (s.setAttribute("for", e), s.textContent = this.label);
  }
  _render() {
    const e = this.getAttribute("id") || this._internalId, t = ["sl-checkbox-input"];
    this.disabled && t.push("sl-checkbox-input--disabled"), this._shadow.innerHTML = `
      <style>${i}</style>
      <div class="sl-checkbox-wrapper">
        <input
          type="checkbox"
          id="${e}"
          class="${t.join(" ")}"
          ${this.checked ? "checked" : ""}
          ${this.disabled ? "disabled" : ""}
          ${this.name ? `name="${this.name}"` : ""}
          ${this.value ? `value="${this.value}"` : ""}
        />
        ${this.label ? `<label for="${e}" class="sl-checkbox-label">${this.label}</label>` : ""}
      </div>
    `, this._input = this._shadow.querySelector("input");
  }
}
typeof customElements < "u" && !customElements.get("sl-checkbox") && customElements.define("sl-checkbox", l);
export {
  l as SlCheckboxElement
};
//# sourceMappingURL=sl-checkbox.js.map
